/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_ACES_SUBMITTED_APPLICATIONS } from './actionTypes';

/**
 * Updates the details in the 'ACESSubmittedApplications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchAcesSubmittedApplicationsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_ACES_SUBMITTED_APPLICATIONS);

/**
 * Updates the indicator of creation of details in the 'ACESSubmittedApplications' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchAcesSubmittedApplicationsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_ACES_SUBMITTED_APPLICATIONS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchAcesSubmittedApplicationsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_ACES_SUBMITTED_APPLICATIONS);

const reducers = combineReducers({
  fetchAcesSubmittedApplications: fetchAcesSubmittedApplicationsReducer,

  isFetchingFetchAcesSubmittedApplications: isFetchingFetchAcesSubmittedApplicationsReducer,
  fetchAcesSubmittedApplicationsError: fetchAcesSubmittedApplicationsErrorReducer,
});

export default { reducers };
